import {AdviceCtaKind} from './adviceVerdict'
import {PriceTrendMessageKey} from './messages'

/**
 * Maps recommendation messageKey to analytics insightType
 */
const INSIGHT_TYPE_MAP: Record<string, string> = {
  recommendationCheaperThanSimilar: 'goodDeal',
  recommendationPricesDropped: 'goodDeal',
  recommendationTypicalInArea: 'fairPrice',
  recommendationPricesStable: 'fairPrice',
  recommendationHigherThanSimilar: 'seeMoreStays',
  recommendationPricesIncreased: 'waitForDrop'
}

/**
 * Maps button messageKey to analytics actionType
 */
const ACTION_TYPE_MAP: Record<string, string> = {
  viewRoomsFromValue: 'scrollToRooms',
  freezeDealsFromValue: 'freezeDeal',
  viewDealFromValue: 'viewRedirectOffer'
}

/**
 * Maps infoCardName to analytics tooltipType
 */
const TOOLTIP_TYPE_MAP: Record<string, string> = {
  'price-trend-hotel-change': 'hotelPriceChange',
  'price-trend-similar-hotels': 'similarHotelsComparison',
  'price-trend-hotel-change-bottomsheet': 'hotelPriceChange',
  'price-trend-similar-hotels-bottomsheet': 'similarHotelsComparison',
  'price-trend-deal-freeze-explainer': 'dealFreezeExplainer'
}

export const getInsightType = (
  recommendationMessageKey: string | undefined
): string | null => {
  if (!recommendationMessageKey) return null
  return INSIGHT_TYPE_MAP[recommendationMessageKey] ?? null
}

/**
 * Derives actionType from button messageKey with seeMoreStays override.
 * When insightType is 'seeMoreStays' (BetterValueCarousel visible), actionType is 'seeMoreStays'.
 */
export const getActionType = (
  buttonMessageKey: PriceTrendMessageKey | null | undefined,
  insightType: string | null
): string | null => {
  if (insightType === 'seeMoreStays') return 'seeMoreStays'
  if (!buttonMessageKey) return null
  return ACTION_TYPE_MAP[buttonMessageKey] ?? null
}

/**
 * Maps the Our Advice CTA kind to analytics actionType (same vocabulary as
 * ACTION_TYPE_MAP). The variant panel's rendered CTA can differ from the
 * control button label (e.g. a freezable low-band offer shows "View rooms",
 * not "Freeze deals"), so treatment sheet-open events report the CTA the user
 * actually sees rather than the control label.
 */
const ADVICE_ACTION_TYPE_MAP: Record<AdviceCtaKind, string> = {
  viewFreezableDeals: 'freezeDeal',
  viewAlternatives: 'seeMoreStays',
  viewRooms: 'scrollToRooms',
  viewDeal: 'viewRedirectOffer'
}

export const getAdviceActionType = (kind: AdviceCtaKind): string =>
  ADVICE_ACTION_TYPE_MAP[kind]

export const getTooltipType = (infoCardName: string): string | null => {
  return TOOLTIP_TYPE_MAP[infoCardName] ?? null
}

export const getApLayout = (isVioOffer: boolean): 'rsp' | 'ap' => {
  return isVioOffer ? 'rsp' : 'ap'
}
